import { Component, OnInit, Injector, ViewChild, ElementRef, AfterViewInit, Input, HostListener } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';
import { ICurrencyFormatter, Currencyformatters } from '../../interfaces/ICurrencyFormatters';

import { Leaderboard, Tournament, TournamentAwards } from '../../api/DixApiClient';
import { ILeaderBoardReq, ILeaderBoardRs } from '../../interfaces/service.response';
import { DataService } from '../../services/data/data.service';
import * as moment from "moment";
import { ShowCompetitionRegisterModal } from '../modals/competitionRegistration/show-competition-registration-modal';
import { filter } from 'rxjs/operators';
import { Utils } from '../../utils';
import { ShowYesNoOrderModal } from '../modals/yesno/yesno.component';
import {Providers} from '../../enums/providers';

@Component({
  selector: 'app-leaderBoard',
  template: require('./leaderBoard.component.html'),
  styles: [require('./leaderBoard.component.scss')]
})
export class LeaderBoardComponent extends AppComponentBase implements OnInit, AfterViewInit {


  private _type:string = ""
  @Input() public set type(v:string)
  {
    this._type = v;
  }

  public get type():string
  {
    return this._type;
  }

private _ismodal:boolean = false;
  @Input() public set ismodal(v:boolean)
  {
    this._ismodal = v;
  }

  public get ismodal():boolean
  {
    return this._ismodal;
  }


  public countentUnits:string = "Days | Hours | Minutes | Seconds";
  public _tournamentID:number = -1;
  public _headerImage:string = "";
  @Input() public set tournamentId(v:number)
  {
      this._tournamentID = v;

      if(v!=-1 && ( this.type=="active" || this.type=="results"))
      {
        this.refresh();
      }
  }

  @Input() public set HeaderImage(v:string)
  {
  //    console.log("HeaderImage");
   //   console.log(v);

      this._headerImage = v;
  }

  public get HeaderImage()
  {
    return this._headerImage;
  }


  public get tournamentId():number{
    return this._tournamentID;
  }

 public currentTimeout:any;
  constructor(injector: Injector) {

    super(injector);

    this.workspace.quoteTabsActiveModeService.subscriber.subscribe(v=>{
    //  console.log("this.workspace.quoteTabsActiveModeService.subscriber")
    //  console.log(v)
      if(v=="leaderboard" && this.type=="active")
      {
        clearTimeout(this.currentTimeout);
        this.refresh();
      }
    })



    this.workspace.globaGridMode.upcomingCLoseSignal.subscribe((v)=>{
     // this.showAwards = false;
 //       console.log(v);
      if(this.type=='upcoming')
      {
        if(v.contains('clickIgnoreClass_' + this.tournamentId) || v.contains("bchx") || v.contains("clickIgnoreModal"))
        {
         // console.log("IGNORE IT")
        }
        else
        {
          this.showAwards = false;
        }
      }
    })
   
    this.dataService.dataSubscriber.subscribe(response => {
      if (response.Type == "LeaderBoardRs") {
        clearTimeout(this.currentTimeout);
          var leaderBoardResponse: ILeaderBoardRs = <ILeaderBoardRs>response;
          if(this.tournamentId==leaderBoardResponse.TournamentId)
          {
            if(leaderBoardResponse.TournamentType == "PIPS")
            {
              this.pipTournament = true;
            }
           

          this.leadeboardList = leaderBoardResponse.ContestantResults.map(v => {
              let t = new LeaderboardExt();
              t.accountId = v.AccountId;
              t.accountName = v.AccountName;
              t.pnL = v.PnL;
              t.place = v.Place;
              t.isCurrentUser = v.IsCurrentUser;
              t.Pips = v.Pips
              return t;
          });

          if(this.type=="active")
          {
             this.currentTimeout = setTimeout(() => {
              this.refresh()
            }, 60*1000);
          }
           

        }

          

      }
  });
  
   }


   public placeSuffix(k:any)
   {

     let i = Number(k);
     if(i==1)
     {
       return "st";
     }

     if(i==2)
     {
       return "nd";
     }

     if(i==3)
     {
       return "rd";
     }

     return "th";
   }


  ngOnInit() {
  }

  private _pipTournament: boolean = false;
  public get pipTournament (): boolean {
    return this._pipTournament;
  }
  public set pipTournament ( value: boolean ) {
    this._pipTournament = value;
  }

  private formatters:ICurrencyFormatter = Currencyformatters;
  private currency: string = "USD";
  

  private _showNumberOfPositions: number = 3;
  public get showNumberOfPositions (): number {
    return this._showNumberOfPositions;
  }
  public set showNumberOfPositions ( value: number ) {
    this._showNumberOfPositions = value;
  }

    
  private _leadeboardList: Leaderboard[] = [];
  public get leadeboardList (): Leaderboard[] {
    return this._leadeboardList;
  }
  public set leadeboardList ( value: Leaderboard[] ) {
    this._leadeboardList = value;
  }


  public get leaders(): Leaderboard[] {
    return this.leadeboardList.slice(0,this.showNumberOfPositions)
  }


  public get tournament():any
  {
    if(this.type=="active")
    {
      let tournament:Tournament[] = this.workspace.currentTournaments.filter((v)=>
      {
        if(v.id==this.tournamentId)
        {
          return v;
        }
       
      })
      
      return tournament[0];//.tournamentAwards;
    }

    if(this.type=="results")
    {
      let tournament:Tournament[] = this.workspace.lastTournaments.filter((v)=>
      {
        if(v.id==this.tournamentId)
        {
          return v;
        }
       
      })
      
      return tournament[0];//.tournamentAwards;
    }

    if(this.type=="upcoming")
    {
      let tournament:Tournament[] = this.workspace.upcomingTournaments.filter((v)=>
      {
        if(v.id==this.tournamentId)
        {
          return v;
        }

       
      })
       return tournament[0];//.tournamentAwards;
    }

   // return [];
  }





  public get awardList():any
  {
    return this.tournament.tournamentAwards;
  }
  

  private _hideAllResults: boolean = false;
  public get hideAllResults (): boolean {
    return this._hideAllResults;
  }
  public set hideAllResults ( value: boolean ) {
    this._hideAllResults = value;
  }

public hideAllResultsAction()
{
  if(this.type=="results")
  {
    this.hideAllResults = true;
    this.showAwards = false;
  }
}

  public get canShow():boolean
  {
    if(this.HeaderImage!=null&&this.HeaderImage!="")
    {
      return true;
    }
    else
    {
      return false
    }
  }

  public get firstPlace()
  {
    if(this.awardList[0]!=undefined)
    {
      return this.awardList![0].prize;
    }
    else{
      return ""
    }
  }

  public get UserPosition()
  {

    let accountIds:Leaderboard[] = this._leadeboardList.filter((v)=>{
      if(v.isCurrentUser)
      {
         return v
      }
     
    })

    return accountIds[0];
  }


  get showUserPosition()
  {
    return this.UserPosition!==undefined;
    // if(this.UserPosition!==undefined)
    // {
    //   if(this.UserPosition.place!==null&&this.UserPosition.place!==undefined)
    //   {
    //     if(this.UserPosition.place>this.showNumberOfPositions)
    //     {
    //        return true
    //     }
    //     else
    //     {
    //       return true
    //     }
       
    //   }
    // }
    // return false;
  }

  public refresh()
  {
    //this.workspace.loadLeaderBoards();
    let LeaderBoardReq:ILeaderBoardReq = {TournamentId:this.tournamentId}

    this.dataService.sendRequest({
        Cmd: DataService.TYPE_LEADERBOARD,
        Data: LeaderBoardReq
    });
  }

  public formattedCurrency(val:any)
  {

      return this.formatters[this.currency].format(val);
   
  }

  public pipsFormater( val:any)
  {
    return Number(val).toFixed(1);
  }

  get isActiveTournamentForUser()
    {
        return this.workspaceService.data.activeTournaments!.length>0
    }


    ngAfterViewInit (): void {
    //  this.initScroll();
    }

   
    private _showAwards: boolean = false;
  public get showAwards (): boolean {
    return this._showAwards;
  }
  public set showAwards ( value: boolean ) {
    this.showNumberOfPositions = value? 10: 3;
    this._showAwards = value;

    if(this.type=='results' && value==true)
    {
        this.hideAllResults = false;
    }
  }


  public get startCompetitionDate (): string {
   
    // console.log( "this.tournament.startDateUtc")
    // console.log( this.tournament.startDateUtc)
    // console.log( this.tournament)

    return  this.tournament.startDateUtc.tz( moment.tz.guess() ).format('YYYY-MM-DD HH:mm:ss');
  
   // return  this.competition.startDateUtc.tz( moment.tz.guess() ).format('YYYY-MM-DD HH:mm:ss');

   }

   public get userIsInRegistered():boolean
   {

    let isUser = this.workspace.tournamentsWithUser!.filter((v)=>{
      if(v.id==this.tournamentId)
      {
        return v;
      }

    })

    if(isUser.length>0)
    {
      return true;
    }

    return false
   }


   public showRules()
   {
     this.showAwards = true;
     const tournament = this.tournament as Tournament;
     if(tournament.rulesUrl == undefined)
      return;
     Utils.openPopup(tournament.rulesUrl, 'web', 750, 550)
   }

   public showCompeteRegistrationModal()
  {

    if(this.workspace.currentProvider!="DEMO" && this.showAwards)
    {
      ShowYesNoOrderModal(this.modalService).updateData("Challenges","PremiereTrade Challenges only available in Demo Accounts. Connect to Demo Account?",this,"");
      return;
    }

    //console.log("[this.workspace.tournamentsWithUser,this.tournamentId");
    //console.log([this.workspace.tournamentsWithUser,this.tournamentId]);
    
    //this.showAwards = !this.showAwards; 

   if(this.showAwards)
   {
      ShowCompetitionRegisterModal(this.modalService, this.tournament, undefined, undefined, undefined, undefined, undefined, this.workspace.mobileMode)
   }
  else
  {
     this.showAwards = !this.showAwards; 
  }
   
  }


  public acceptAction()
  {
    //alert("Accepterd");
    this.workspace.currentProvider = Providers.DEMO;
    this.globaGridMode.switchProviderSignal.next(this.workspace.currentProvider);
  }


  public modalShowCompeteRegistrationModal()
  {

    if(this.workspace.currentProvider!="DEMO" && this.showAwards)
    {
      ShowYesNoOrderModal(this.modalService).updateData("Challenges","PremiereTrade Challenges only available in Demo Accounts. Connect to Demo Account?",this,"");
      return;
    }

    ShowCompetitionRegisterModal(this.modalService, this.tournament, undefined, undefined, undefined, undefined, undefined, this.workspace.mobileMode)
  }


  @HostListener("document:click", ["$event"])
  clickout(even: any) {

    

        if(this.showAwards==true)
        {
           this.workspace.globaGridMode.upcomingCLoseSignal.next(even.target.classList);
        }
       

      }
  












}


export class LeaderboardExt extends Leaderboard
{
  Pips?:number
}